import { render } from "./adminManageModal.vue?vue&type=template&id=659b6697&ts=true"
import script from "./adminManageModal.vue?vue&type=script&lang=ts"
export * from "./adminManageModal.vue?vue&type=script&lang=ts"

import "./adminManageModal.vue?vue&type=style&index=0&id=659b6697&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__